import parse from "html-react-parser";
import DOMPurify from "dompurify";

export const parseHtmlContent = (html) =>
  parse(DOMPurify.sanitize(html ?? ""));
